import axios from 'axios'
import services from '@/config/services'
import authHeader from '../auth/auth-header';
import Cookies from 'js-cookie';
import FileManager from '@/services/ask-file-manager/index.js'

export default class PraticheService{
  constructor(eventBus){
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api_landing.url}`
    this.baseUrlToken = `${services.ask_api_landing_token.url}`
    this.filemanager = new FileManager()
    // axios.interceptors.request.use(
    //   (req) => {
    //     req.headers["Authorization"] = authHeader()
    //     req.headers["Params"] = Cookies.get('google_access_token') || Cookies.get('ask_access_token')
    //     // this.eventBus.emit('data-loading');
    //     return req
    //   }
    // )
  }

    // async verifyTokenLinkLibero(token){
    //     let items = null
    //     const url = `${this.baseUrlToken}/verifica-token-caricamento`
    
    //     try {
    //         let res = await axios.post(url, {token})
    //         items = res.data
    //     } catch (err) {
    //         this.eventBus.emit('data-load-error', {message: err, url})
    //     } finally {
    //         this.eventBus.emit('data-loaded')      
    //         // eslint-disable-next-line no-unsafe-finally
    //         return {
    //             items
    //         }
    //     }
    // }
    
    // async getDataOffertaFromToken(token){
    //     let items = null
    //     const url = `${this.baseUrl}/get-data-from-token`
    
    //     try {
    //         let res = await axios.post(url, {token})
    //         items = res.data
    //     } catch (err) {
    //         this.eventBus.emit('data-load-error', {message: err, url})
    //     } finally {
    //         this.eventBus.emit('data-loaded')      
    //         // eslint-disable-next-line no-unsafe-finally
    //         return {
    //             items
    //         }
    //     }
    // }
    async exist_token(token){
        let items = null
        const url = `${this.baseUrl}/exist-token`
        try {
            let res = await axios.post(url, {token})
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', {message: err, url})
        } finally {
            this.eventBus.emit('data-loaded')      
            // eslint-disable-next-line no-unsafe-finally
            return {
                items
            }
        }
    }

    async get_offerte_agf(token){
        let items = null
        const url = `${this.baseUrl}/token-agf/get-offerte`
        try {
            let res = await axios.post(url, {token})
            items = res?.data?.items ?? res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', {message: err, url})
        } finally {
            this.eventBus.emit('data-loaded')
            // eslint-disable-next-line no-unsafe-finally
            return {
                items
            }
        }
    }

    async verify_invite_code({ invite_code, ref, token, session_id }){
        let items = null
        const url = `${this.baseUrl}/token-agf/verify-invite-code`
        try {
            const payload = {}
            if (invite_code !== undefined) payload.invite_code = invite_code
            if (ref !== undefined) payload.ref = ref
            if (token !== undefined) payload.token = token
            if (session_id !== undefined) payload.session_id = session_id
            const res = await axios.post(url, payload)
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', {message: err, url})
            throw err
        } finally {
            this.eventBus.emit('data-loaded')
        }
        return { items }
    }

    async save_wizard_step({ token, step, selectedCommodity, session_id, invite_code, form, data }) {
        let items = null
        const url = `${this.baseUrl}/token-agf/save-wizard-step`
        const formObj = form || {}
        const bollettaFile = formObj?.ultimaBolletta instanceof File ? formObj.ultimaBolletta : null
        const documentoFile = formObj?.documentoIdentita instanceof File ? formObj.documentoIdentita : null
        let payload = { token, step }
        let config = undefined

        if (bollettaFile || documentoFile) {
            payload = new FormData()
            payload.append('token', token)
            payload.append('step', String(step))
            if (selectedCommodity !== undefined) payload.append('selectedCommodity', selectedCommodity)
            if (session_id !== undefined) payload.append('session_id', session_id)
            if (invite_code !== undefined) payload.append('invite_code', invite_code)

            Object.entries(formObj).forEach(([key, value]) => {
                if (value === undefined || value === null) return
                if (key === 'ultimaBolletta' || key === 'documentoIdentita') return
                let normalized = value
                if (typeof value === 'boolean') normalized = value ? '1' : '0'
                payload.append(`form[${key}]`, normalized)
            })
            if (bollettaFile) {
                payload.append('form[ultimaBolletta]', bollettaFile.name)
                payload.append('fileBolletta', bollettaFile)
            }
            if (documentoFile) {
                payload.append('form[documentoIdentita]', documentoFile.name)
                payload.append('documentoIdentita', documentoFile)
            }
            if (data !== undefined) payload.append('data', JSON.stringify(data))
            config = { headers: { 'content-type': 'multipart/form-data' } }
        } else {
            if (selectedCommodity !== undefined) payload.selectedCommodity = selectedCommodity
            if (session_id !== undefined) payload.session_id = session_id
            if (invite_code !== undefined) payload.invite_code = invite_code
            if (form !== undefined) payload.form = form
            if (data !== undefined) payload.data = data
        }

        try {
            const res = await axios.post(url, payload, config)
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', { message: err, url })
            throw err
        }
        finally {
            this.eventBus.emit('data-loaded')
        }
        return { items }
    }

    async request_phone_otp({ token, telefono }) {
        let items = null
        const url = `${this.baseUrl}/token-agf/request-phone-otp`
        const payload = { token, telefono }

        try {
            const res = await axios.post(url, payload)
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', { message: err, url })
        } finally {
            this.eventBus.emit('data-loaded')
        }

        return { items }
    }

    async verify_phone_otp({ token, otp, telefono, session_id }) {
        let items = null
        const url = `${this.baseUrl}/token-agf/verify-phone-otp`
        const payload = { token, otp }
        if (telefono !== undefined) payload.telefono = telefono
        if (session_id !== undefined) payload.session_id = session_id

        try {
            const res = await axios.post(url, payload)
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', { message: err, url })
        } finally {
            this.eventBus.emit('data-loaded')
        }

        return { items }
    }

    async send_summary_email({ token, session_id }) {
        let items = null
        const url = `${this.baseUrl}/token-agf/send-summary-email`
        const payload = { token }
        if (session_id !== undefined) payload.session_id = session_id

        try {
            const res = await axios.post(url, payload)
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', { message: err, url })
            throw err
        } finally {
            this.eventBus.emit('data-loaded')
        }

        return { items }
    }

    async submit_completed_wizard({ token, session_id, fileBolletta, documentoIdentita, log_id, cod_comune_cliente, cod_comune_fornitura, cellulare, email }) {
        let items = null
        const url = `${this.baseUrl}/token-agf/submit-completed-wizard`
        let payload = { token }
        let config = undefined
        const firstFile = (v) => {
            if (!v) return null
            if (v instanceof File) return v
            if (typeof FileList !== 'undefined' && v instanceof FileList) return v[0] || null
            if (Array.isArray(v)) return v[0] || null
            return null
        }
        const bollettaFile = firstFile(fileBolletta)
        const identitaFile = firstFile(documentoIdentita)

        if (session_id !== undefined) payload.session_id = session_id
        if (log_id !== undefined) payload.log_id = log_id
        if (cellulare !== undefined) payload.cellulare = cellulare
        if (email !== undefined) payload.email = email
        if (cod_comune_cliente !== undefined) payload.cod_comune_cliente = cod_comune_cliente
        if (cod_comune_fornitura !== undefined) payload.cod_comune_fornitura = cod_comune_fornitura

        if (bollettaFile || identitaFile) {
            const fd = new FormData()
            fd.append('token', token)
            if (session_id !== undefined) fd.append('session_id', session_id)
            if (log_id !== undefined) fd.append('log_id', String(log_id))
            if (cellulare !== undefined) fd.append('cellulare', String(cellulare))
            if (email !== undefined) fd.append('email', String(email))
            if (cod_comune_cliente !== undefined) fd.append('cod_comune_cliente', String(cod_comune_cliente))
            if (cod_comune_fornitura !== undefined) fd.append('cod_comune_fornitura', String(cod_comune_fornitura))
            if (bollettaFile) fd.append('fileBolletta', bollettaFile)
            if (identitaFile) fd.append('documentoIdentita', identitaFile)
            payload = fd
            config = { headers: { 'content-type': 'multipart/form-data' } }
        }

        try {
            const res = await axios.post(url, payload, config)
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', { message: err, url })
            throw err
        } finally {
            this.eventBus.emit('data-loaded')
        }

        return { items }
    }

    async sendFormLanding(fd){
        let items = null
        const url = `${this.baseUrlToken}/send-form-landing`
        const settings = { headers: { 'content-type': 'multipart/form-data' } }
        try {
            const res = await axios.post(url, fd, settings)
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', {message: err, url})
        } finally {
            this.eventBus.emit('data-loaded')      
            // eslint-disable-next-line no-unsafe-finally
            return {
                items
            }
        }
    }

    async getDistricts(value = null){
        let items = {}
        const url = `${this.baseUrl}/get-districts/${value}`
    
        try {
            let res = await axios.get(url)
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', {message: err, url})
        } finally {
            this.eventBus.emit('data-loaded')      
            // eslint-disable-next-line no-unsafe-finally
            return {
                items,
            }
        }
    
      }

      async getCities(value = null){
        let items = {}
        const url = `${this.baseUrl}/get-cities/${value}`
    
        try {
            let res = await axios.get(url)
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', {message: err, url})
        } finally {
            this.eventBus.emit('data-loaded')      
            // eslint-disable-next-line no-unsafe-finally
            return {
                items,
            }
        }
      }
      async getDetailPoints(){
        let items = {}        
        const url = `${this.baseUrl}/get-points`
        try {
            const res = await axios.get(url)
            items = res.data
        } catch (err) {
            this.eventBus.emit('data-load-error', {message: err, url})
        } finally {
            this.eventBus.emit('data-loaded')      
            // eslint-disable-next-line no-unsafe-finally
            return {
                items
            }
        }
    }

}
